import * as React from 'react';

/**
 * @description Python icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Python } from '@sravni/design-system-icons'
 *
 * <Python />
 * ```
 */
const Python = React.forwardRef((props, ref) => (React.createElement("svg", { ref: ref, "data-qa": "Python", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.32 3.75A2.75 2.75 0 0 1 9.07 1h3.332a2.75 2.75 0 0 1 2.75 2.75v1.833h1.834a2.75 2.75 0 0 1 2.75 2.75v3.333a2.75 2.75 0 0 1-2.75 2.75h-1.834v1.834a2.75 2.75 0 0 1-2.75 2.75H9.07a2.75 2.75 0 0 1-2.75-2.75v-1.833H4.486a2.75 2.75 0 0 1-2.75-2.75V8.334a2.75 2.75 0 0 1 2.75-2.75H6.32V3.75Zm1.5 1.834h2.916a.75.75 0 0 1 0 1.5h-6.25c-.69 0-1.25.56-1.25 1.25v3.333c0 .69.56 1.25 1.25 1.25H6.32V12a2.75 2.75 0 0 1 2.75-2.75h3.333c.69 0 1.25-.56 1.25-1.25V3.75c0-.69-.56-1.25-1.25-1.25H9.07c-.69 0-1.25.56-1.25 1.25v1.834Zm5.832 8.832h-2.916a.75.75 0 1 1 0-1.5h6.25c.69 0 1.25-.56 1.25-1.25V8.333c0-.69-.56-1.25-1.25-1.25h-1.834V8a2.75 2.75 0 0 1-2.75 2.75H9.07c-.69 0-1.25.56-1.25 1.25v4.25c0 .69.56 1.25 1.25 1.25h3.333c.69 0 1.25-.56 1.25-1.25v-1.834Z", fill: "currentColor" }),
    React.createElement("circle", { cx: "12.111", cy: "15.958", fill: "currentColor", stroke: "currentColor", strokeWidth: "1.2", r: ".458" }),
    React.createElement("circle", { cx: "9.36", cy: "4.042", fill: "currentColor", stroke: "currentColor", strokeWidth: "1.2", r: ".458" }))));

export { Python };
//# sourceMappingURL=Python.js.map
